<template>
  <v-navigation-drawer id="authorNavigator" fixed app
    v-model="config.status.active">
    <v-img :src="getLogo" />
    <AuthorEvents />
    <v-list dense class="pt-0">
      <v-list-item v-for="item in authedNavigation"
        :key="item.path"
        :to="item.path"
        active-class="primary--text primary lighten-5">
        <v-list-item-avatar class="my-1">
          <v-icon small>{{ item.active ? item.meta.icon.active : item.meta.icon.default }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="body-2">{{ item.meta.label }}</v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Logo from '@/assets/logo.png'
import AuthorRoutes from '@/router/author'
import AuthorEvents from '@/components/events'
export default {
  name: 'authorNav',
  components: {
    AuthorEvents
  },
  data () {
    return {
      socket: null,
      config: {
        status: {
          active: true,
          loading: true
        },
        calendar: {
          target: null,
          details: false
        },
        logo: require('@/assets/logo_rectangular.svg')
      },
      calendar: {
        status: {
          active: false
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
    },
    toggle: function () {
      this.$set(this.config.status, 'active', !this.config.status.active)
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    authedNavigation () {
      let auths = this.$store.getters['author/get']('authority')
      let roles = this.$store.getters['author/get']('roles')
      let matches = this.$route.matched.map(it => it.name)
      return AuthorRoutes.routes.filter(rt => {
        return (
          rt.meta &&
          (auths.includes(rt.meta.permit) || roles.includes(rt.meta.permit))
        )
      }).map(rt => {
        return Object.assign({}, rt, {
          active: matches.includes(rt.name),
          path: '/author/' + rt.path
        })
      })
    },
    printToday () {
      return this.$moment().format('YYYY年MM月DD日')
    },
    getLogo () {
      return this.config.logo
    }
  }
}
</script>

<style lang="scss">
#authorNavigator {
  .primary--text {
    background: $mb_c;
    color: $s_c;
  }
}
</style>
